/**
 * Contains predefined subjects that observers can subscribe to.
 */
export default {
  dynamicFooterUpdate: 'dynamicFooterUpdate'
};